import {
  ConcernAboutAStaySubTopicsList,
  WebsiteSupportSubTopicsList,
  MarriottBonvoyAccountAssistanceSubTopicsList,
} from './HotelBookInformation.types';

export const HOTEL_SEARCH_RESULTS = [
  'AC Hotel Elda - Elda, Spain',
  'Fairfield By Marriott Hyogo Tajima Yabu - Yabu, JP-28, Japan',
  'JW Marriott Cannes - Cannes, France',
  'JW Marriott Auckland - Auckland, New Zealand',
  'Los Tajibos Santa Cruz De La Sierra A Tribute Portfolio Hotel - Santa Cruz De La Sierra, Bolivia',
  'Aloft Austin Airport - Austin, TX, USA',
  'Austin Marriott North - Round Rock, TX, USA',
];

export const CONCERN_ABOUT_A_STAY_SUBTOPICS_LIST: ConcernAboutAStaySubTopicsList[] = [
  { label: 'Guest Room Feedback', value: 'GRF' },
  { label: 'Common Space/Exterior Feedback', value: 'CSEF' },
  { label: 'Meeting and Events Feedback', value: 'MEF' },
  { label: 'Staff Feedback', value: 'SF' },
  { label: 'Food and Beverage Feedback', value: 'FBF' },
  { label: 'Lost and Found', value: 'LF' },
  { label: 'Billing Accuracy', value: 'BA' },
];

export const WEBSITE_SUPPORT_SUBTOPICS_LIST: WebsiteSupportSubTopicsList[] = [
  { label: 'BrokenWebsite  Link/URL', value: 'BWLU' },
  { label: 'Spelling or Other Error on Website', value: 'SOEW' },
  { label: 'General Error', value: 'GE' },
  { label: 'Marriott Bonvoy Account Technical Error', value: 'MBATE' },
];

export const MARRIOTT_BONVOY_ACCOUNT_ASSISTANCE_SUBTOPICS_LIST: MarriottBonvoyAccountAssistanceSubTopicsList[] = [
  { label: 'Combine Multiple Marriott Bonvoy Accounts', value: 'CMMBA' },
  { label: 'Benefits Delivery', value: 'BD' },
  { label: 'Earning', value: 'ERN' },
  { label: 'Redemption', value: 'RDPT' },
  { label: 'Other Account Assistance', value: 'OAA' },
];

export const TOPIC_LIST_FOR_SUBTOPICS = ['MS', 'MRMAP'];
